import type { IconProps } from "./thumba-coin";

export const GroupIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...props}>
    <path
      d="M9.95603 11.6614C9.77186 11.4737 9.56793 11.3095 9.34839 11.1668C9.56793 11.3095 9.7729 11.4747 9.95603 11.6614Z"
      fill="#5C5C5C"
    />
    <path
      d="M13.7916 10.83H10.795C10.641 10.83 10.4891 10.8407 10.3403 10.8621C10.4954 11.0027 10.6431 11.1518 10.7794 11.3149C10.924 11.4866 11.0531 11.6701 11.1696 11.86H13.7916C15.1109 11.86 16.1837 12.9661 16.1837 14.3266V16.0959H17.1825V14.3266C17.1825 12.3986 15.6614 10.83 13.7916 10.83Z"
      fill="#5C5C5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.34698 11.1673C9.34721 11.1672 9.34744 11.1671 9.34767 11.167C9.34074 11.1623 9.33392 11.1575 9.3271 11.1528C9.31345 11.1432 9.29981 11.1337 9.28524 11.1251C8.75564 10.7979 8.13551 10.608 7.47377 10.608H4.35128C2.4035 10.608 0.818848 12.2431 0.818848 14.2516V16.1346H1.85933V14.2516C1.85933 14.1626 1.86349 14.0757 1.87181 13.9887C1.88014 13.9029 1.89262 13.8171 1.90927 13.7334C1.93424 13.6079 1.96754 13.4855 2.0102 13.3675C2.108 13.0918 2.25055 12.8386 2.42847 12.6165C2.47946 12.5532 2.53356 12.492 2.58975 12.4341C2.61784 12.4051 2.64697 12.3761 2.67611 12.3493C2.73541 12.2935 2.7968 12.241 2.86131 12.1916C2.89357 12.1669 2.92582 12.1433 2.95912 12.1197C3.059 12.05 3.16305 11.9877 3.2723 11.9341C3.59901 11.771 3.96526 11.6798 4.35232 11.6798H7.47481C7.81088 11.6798 8.13031 11.7485 8.42268 11.8729C8.75148 12.0135 9.04489 12.2238 9.28628 12.4867C9.70872 12.9469 9.9678 13.5682 9.9678 14.2505V16.0938H11.0083V14.2505C11.0083 13.3718 10.7034 12.5661 10.1998 11.9362C10.199 11.9365 10.1981 11.9367 10.1972 11.9369C10.189 11.9269 10.1808 11.9165 10.1725 11.9062C10.1642 11.8957 10.1559 11.8852 10.1475 11.875C10.0862 11.801 10.0217 11.7302 9.95402 11.6615C9.77002 11.4739 9.56629 11.3099 9.34698 11.1673Z"
      fill="#5C5C5C"
    />
    <path
      d="M3.27144 11.9351C3.16219 11.9898 3.05814 12.051 2.95825 12.1207C3.05814 12.051 3.16219 11.9888 3.27144 11.9351Z"
      fill="#5C5C5C"
    />
    <path
      d="M1.91002 13.7343C1.89337 13.818 1.88088 13.9028 1.87256 13.9897C1.88088 13.9038 1.89337 13.818 1.91002 13.7343Z"
      fill="#5C5C5C"
    />
    <circle cx="5.5429" cy="6.76513" r="2.05407" stroke="#5C5C5C" strokeWidth="0.954711" />
    <circle cx="11.6186" cy="6.76513" r="2.05407" stroke="#5C5C5C" strokeWidth="0.954711" />
  </svg>
);
